import React from 'react'
import { BettingOddsUserPick } from './type';

const ODDS_SERVE_UID = '965fe5c2852467f500e1b1a076aa6837'
const COMPETITION_ID = "139"
const SPORT = "1"

function postMatchSelectionToOddsServe(selections: any) {
  console.log("[Swisslos Odds] post selection", selections)

  const oddsServeFrame = (document.querySelector('.eccc554d iframe') as any)?.contentWindow;

  if (!oddsServeFrame) {
    console.log(" -> No oddsServeFrame present")

    return;
  }

  oddsServeFrame.postMessage(selections,'*');
}

export const makeInitialSwisslosRenderCall = () => {
  (window as any).oddsServe?.(ODDS_SERVE_UID, 1, 139)
  console.log("[Swisslos Odds] inital call")
}

export const notifySwisslosPickChange = (matchId: string, pick: BettingOddsUserPick) => {
  postMatchSelectionToOddsServe([{matchId, competitionId: COMPETITION_ID, outcome: pick}])
}

const SwisslosBettingOdds: React.FC<{ matchId: string, initialPick?: BettingOddsUserPick}> = ({ matchId, initialPick }) => {
  return <span className="oddsServe" data-sport={SPORT} data-match={matchId} data-competition={COMPETITION_ID} {... initialPick ? { "data-outcome": initialPick } : {}} />
}

export default SwisslosBettingOdds
